var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDefaultProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 28,
    fill: "#B5B5B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.2477C32.0056 28.2477 33.9291 27.4444 35.3473 26.0147C36.7655 24.585 37.5623 22.6458 37.5623 20.6238C37.5623 18.6019 36.7655 16.6627 35.3473 15.233C33.9291 13.8032 32.0056 13 30 13C27.9944 13 26.0709 13.8032 24.6527 15.233C23.2345 16.6627 22.4377 18.6019 22.4377 20.6238C22.4377 22.6458 23.2345 24.585 24.6527 26.0147C26.0709 27.4444 27.9944 28.2477 30 28.2477ZM30 31.5972C19.9455 31.5972 13.5 37.1909 13.5 39.9144V45H46.5V39.9144C46.5 36.6208 40.398 31.5972 30 31.5972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDefaultProfile);
export default __webpack_public_path__ + "static/media/ico-default-profile.204d41714b51b83cd6b07c2e69bd9ebd.svg";
export { ForwardRef as ReactComponent };